import { Developer } from '../components/Settings/Developer/Developer'

export const DeveloperPage = () => {
    return <Developer />
}
